window.Promise  = require('promise-polyfill')
_               = require('underscore')
domready        = require('domready')
error           = require('shared/util/error')
error.init()

require('es6-object-assign').polyfill()
require('shared/util/request_animation_frame_polyfill')

document.addEventListener 'touchstart', (->), true

# config
config = require('shared/util/site_settings')

# i18n
i18nConfig = { locale: config.i18n.locale, messages: {} }
i18nConfig.messages[config.i18n.locale] = config.i18n.translations

# run
try
  Vue         = require('vue/dist/vue')
  Vuex        = require('vuex').default
  VueI18n     = require('vue-i18n').default
  VueRollbar  = require('shared/plugins/vue_rollbar')
  VuePopups   = require('shared/plugins/popups').VuePopups

  Vue.use(Vuex)
  Vue.use(VueI18n)
  Vue.use(VueRollbar)
  Vue.use(VuePopups)

  require('./components/globals')(Vue)

  store = new (require('./store'))()

  # ------------------------------------------------

  window.app = new Vue
    store:  store.getVuexStore()
    i18n:   new VueI18n(i18nConfig)

    created: ->
      store.setup()

  domready ->
    app.$mount('#page-wrapper')

catch e
  error.TraceKit.report(e)





// WEBPACK FOOTER //
// ./assets/js/frontend/main.coffee